import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

import { Dialog, DialogFooter, DialogHeader, FormField } from "@/ds";
import { CampoDecimal } from "@/shared/components";
import {
  CANCELAR_LABEL,
  COTACAO_ESCOPO_MESSAGE,
  COTACAO_LABEL,
  COTACAO_TITLE,
  MOEDA_LABEL,
  SALVAR_LABEL,
} from "./cotacao-dialog.constants";
import modal from "../planejamento-controle.modal.module.scss";
import styles from "./cotacao-dialog.module.scss";
import type { CotacaoDialogViewModel } from "./types-cotacao-dialog";

const RODAPE_DIALOGO = { footer: { className: modal.dialogoRodape } };

export function CotacaoDialogView({
  formId,
  moedaCodigo,
  cotacao,
  cotacaoError,
  foco,
  isSubmitting,
  submitError,
  digitarCotacao,
  enviar,
  cancelar,
}: CotacaoDialogViewModel) {
  return (
    <Dialog
      visible
      size="md"
      className={styles.dialogo}
      contentClassName={styles.corpo}
      onHide={cancelar}
      locked={isSubmitting}
      focusOnShow={false}
      header={<DialogHeader title={COTACAO_TITLE(moedaCodigo)} />}
      pt={RODAPE_DIALOGO}
      footer={
        <DialogFooter
          className={modal.rodape}
          cancelLabel={CANCELAR_LABEL}
          confirmLabel={SALVAR_LABEL}
          formId={formId}
          loading={isSubmitting}
          locked={isSubmitting}
          onCancel={cancelar}
          testId="cotacao"
        />
      }
      data-testid="cotacao-dialog"
    >
      <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
        <p className={styles.texto}>{COTACAO_ESCOPO_MESSAGE}</p>
        <div className={styles.campos}>
          <FormField.Root disabled>
            <FormField.Label>{MOEDA_LABEL}</FormField.Label>
            <FormField.Control>
              <InputText value={moedaCodigo} readOnly data-testid="cotacao-moeda" />
            </FormField.Control>
          </FormField.Root>
          <CampoDecimal
            label={COTACAO_LABEL}
            casas={6}
            value={cotacao}
            onChange={digitarCotacao}
            error={cotacaoError}
            disabled={isSubmitting}
            foco={foco}
            testId="cotacao-campo"
          />
        </div>
        {submitError ? (
          <Message
            className="p-message-block"
            severity="error"
            text={submitError}
            data-testid="cotacao-submit-error"
          />
        ) : null}
      </form>
    </Dialog>
  );
}
